module.exports = __webpack_public_path__ + "media/images/banner/planning/ko-811fd8e1d4fc64646d06278575c8e918.jpg";